/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StockUpdateBase } from './StockUpdateBase';
import {
    StockUpdateBaseFromJSON,
    StockUpdateBaseFromJSONTyped,
    StockUpdateBaseToJSON,
    StockUpdateBaseToJSONTyped,
} from './StockUpdateBase';
import type { StockPlanUpdateBase } from './StockPlanUpdateBase';
import {
    StockPlanUpdateBaseFromJSON,
    StockPlanUpdateBaseFromJSONTyped,
    StockPlanUpdateBaseToJSON,
    StockPlanUpdateBaseToJSONTyped,
} from './StockPlanUpdateBase';
import type { PendingOrderNextDay } from './PendingOrderNextDay';
import {
    PendingOrderNextDayFromJSON,
    PendingOrderNextDayFromJSONTyped,
    PendingOrderNextDayToJSON,
    PendingOrderNextDayToJSONTyped,
} from './PendingOrderNextDay';
import type { OrderPlanTransportLot } from './OrderPlanTransportLot';
import {
    OrderPlanTransportLotFromJSON,
    OrderPlanTransportLotFromJSONTyped,
    OrderPlanTransportLotToJSON,
    OrderPlanTransportLotToJSONTyped,
} from './OrderPlanTransportLot';

/**
 * 
 * @export
 * @interface OrderPlanTransportLotUpdateBase
 */
export interface OrderPlanTransportLotUpdateBase {
    /**
     * 発注日の確定入荷数
     * @type {Array<StockPlanUpdateBase>}
     * @memberof OrderPlanTransportLotUpdateBase
     */
    stockPlanList: Array<StockPlanUpdateBase>;
    /**
     * 発注日の確定輸送ロット
     * @type {Array<OrderPlanTransportLot>}
     * @memberof OrderPlanTransportLotUpdateBase
     */
    orderPlanTransportLotList: Array<OrderPlanTransportLot>;
    /**
     * 調整日の発注数（未確定）
     * @type {Array<PendingOrderNextDay>}
     * @memberof OrderPlanTransportLotUpdateBase
     */
    pendingOrderNextDay: Array<PendingOrderNextDay>;
    /**
     * 在庫など再計算
     * @type {Array<StockUpdateBase>}
     * @memberof OrderPlanTransportLotUpdateBase
     */
    stockList: Array<StockUpdateBase>;
}

/**
 * Check if a given object implements the OrderPlanTransportLotUpdateBase interface.
 */
export function instanceOfOrderPlanTransportLotUpdateBase(value: object): value is OrderPlanTransportLotUpdateBase {
    if (!('stockPlanList' in value) || value['stockPlanList'] === undefined) return false;
    if (!('orderPlanTransportLotList' in value) || value['orderPlanTransportLotList'] === undefined) return false;
    if (!('pendingOrderNextDay' in value) || value['pendingOrderNextDay'] === undefined) return false;
    if (!('stockList' in value) || value['stockList'] === undefined) return false;
    return true;
}

export function OrderPlanTransportLotUpdateBaseFromJSON(json: any): OrderPlanTransportLotUpdateBase {
    return OrderPlanTransportLotUpdateBaseFromJSONTyped(json, false);
}

export function OrderPlanTransportLotUpdateBaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderPlanTransportLotUpdateBase {
    if (json == null) {
        return json;
    }
    return {
        
        'stockPlanList': ((json['stockPlanList'] as Array<any>).map(StockPlanUpdateBaseFromJSON)),
        'orderPlanTransportLotList': ((json['orderPlanTransportLotList'] as Array<any>).map(OrderPlanTransportLotFromJSON)),
        'pendingOrderNextDay': ((json['pendingOrderNextDay'] as Array<any>).map(PendingOrderNextDayFromJSON)),
        'stockList': ((json['stockList'] as Array<any>).map(StockUpdateBaseFromJSON)),
    };
}

export function OrderPlanTransportLotUpdateBaseToJSON(json: any): OrderPlanTransportLotUpdateBase {
    return OrderPlanTransportLotUpdateBaseToJSONTyped(json, false);
}

export function OrderPlanTransportLotUpdateBaseToJSONTyped(value?: OrderPlanTransportLotUpdateBase | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'stockPlanList': ((value['stockPlanList'] as Array<any>).map(StockPlanUpdateBaseToJSON)),
        'orderPlanTransportLotList': ((value['orderPlanTransportLotList'] as Array<any>).map(OrderPlanTransportLotToJSON)),
        'pendingOrderNextDay': ((value['pendingOrderNextDay'] as Array<any>).map(PendingOrderNextDayToJSON)),
        'stockList': ((value['stockList'] as Array<any>).map(StockUpdateBaseToJSON)),
    };
}

